import React, { useEffect, useRef } from "react";

function cloneHeadNode(node) {
  if (node.tagName === "STYLE") {
    const styleEl = document.createElement("style");
    styleEl.textContent = node.textContent;
    return styleEl;
  }

  if (node.tagName === "LINK") {
    const linkEl = document.createElement("link");
    Array.from(node.attributes).forEach((attr) => {
      linkEl.setAttribute(attr.name, attr.value);
    });
    return linkEl;
  }

  return null;
}

function runScriptsFromDocument(doc) {
  const mountedScripts = [];
  const scripts = doc.querySelectorAll("script");

  scripts.forEach((oldScript) => {
    const scriptEl = document.createElement("script");
    Array.from(oldScript.attributes).forEach((attr) => {
      scriptEl.setAttribute(attr.name, attr.value);
    });

    if (oldScript.src) {
      scriptEl.src = oldScript.src;
    } else {
      scriptEl.textContent = oldScript.textContent;
    }

    scriptEl.async = false;
    scriptEl.setAttribute("data-elverve-branded", "true");
    document.body.appendChild(scriptEl);
    mountedScripts.push(scriptEl);
  });

  return mountedScripts;
}

const ElverveBranded = () => {
  const rootRef = useRef(null);

  useEffect(() => {
    let isMounted = true;
    const mountedHeadNodes = [];
    let mountedScripts = [];
    const prevTitle = document.title;

    const loadPage = async () => {
      const response = await fetch("/elverve-branded.html", {
        cache: "no-cache",
      });

      if (!response.ok) {
        throw new Error("Failed to load /elverve-branded.html");
      }

      const html = await response.text();
      if (!isMounted || !rootRef.current) {
        return;
      }

      const parser = new DOMParser();
      const parsedDoc = parser.parseFromString(html, "text/html");

      if (parsedDoc.title) {
        document.title = parsedDoc.title;
      }

      parsedDoc
        .querySelectorAll(
          'head style, head link[rel="stylesheet"], head link[rel="preconnect"]',
        )
        .forEach((node) => {
          const cloned = cloneHeadNode(node);
          if (!cloned) {
            return;
          }

          cloned.setAttribute("data-elverve-branded", "true");
          document.head.appendChild(cloned);
          mountedHeadNodes.push(cloned);
        });

      rootRef.current.innerHTML = parsedDoc.body.innerHTML;
      mountedScripts = runScriptsFromDocument(parsedDoc);
    };

    loadPage().catch(() => {
      if (!rootRef.current) {
        return;
      }

      rootRef.current.innerHTML =
        '<div style="padding:24px;font-family:system-ui,sans-serif">Unable to load AI Readiness page.</div>';
    });

    return () => {
      isMounted = false;
      document.title = prevTitle;

      if (rootRef.current) {
        rootRef.current.innerHTML = "";
      }

      mountedScripts.forEach((scriptEl) => {
        scriptEl.remove();
      });

      mountedHeadNodes.forEach((headNode) => {
        headNode.remove();
      });
    };
  }, []);

  return <div ref={rootRef} />;
};

export default ElverveBranded;
